import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

interface FieldValue {
  name: string;
  value: string;
  predefined?: boolean;
  private?: boolean;
  readonly?: boolean;
  type?: 'boolean' | 'number' | 'string' | 'date' | 'email' | 'gender' | 'country' | 'consent' | 'phone' | 'permission';
}

interface DopplerSubscriber {
  email: string;
  fields?: FieldValue[];
  status?: 'active' | 'pending' | 'unsubscribed' | 'standBy';
}

@Injectable({
  providedIn: 'root'
})
export class DopplerService {
  private readonly API_URL = 'https://restapi.fromdoppler.com/accounts';
  private readonly ACCOUNT_NAME = 'marketing@vittal.com.ar';
  private readonly LIST_ID = '29076950';
  private readonly API_KEY = '38E272DFE673B985E7AC24A4A681B663';

  constructor(private http: HttpClient) { }

  submitForm(formData: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `token ${this.API_KEY}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Doppler-Subscriber-Origin': 'Landing DEA'
    });

    const subscriber: DopplerSubscriber = {
      email: formData.email,
      fields: [
        {
          name: 'FIRSTNAME',
          value: formData.nombre,
          type: 'string'
        },
        {
          name: 'LASTNAME',
          value: formData.apellido,
          type: 'string'
        },
        {
          name: 'Empresa',
          value: formData.empresa || '',
          type: 'string'
        },
        {
          name: 'Celular',
          value: formData.telefono,
          type: 'phone'
        },
        {
          name: 'Localidad',
          value: formData.localidad || '',
          type: 'string'
        }
      ],
      status: 'active'
    };

    return this.http.post(
      `${this.API_URL}/${this.ACCOUNT_NAME}/lists/${this.LIST_ID}/subscribers`,
      subscriber,
      { headers }
    );
  }
}